// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"152":"1ae403d1","287":"cccb36e7","328":"c30bb226","453":"2c6f7d7d","841":"874eb6ac"}[chunkId] + ".chunk.js";
};